<script>
    import {Route,router,active} from 'tinro'; 
    const meta = router.meta()
</script>
  
<div class="row">
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
    {#each meta.breadcrumbs as bc, i}
        {#if meta.breadcrumbs.length == (i+1)}
            <li class="breadcrumb-item active">{bc.name}</li>
        {:else}
            <li class="breadcrumb-item"><a href={bc.path}>{bc.name}</a></li>
        {/if}
    {/each}
    </ol>
</nav>
</div>
